module.exports = __webpack_public_path__ + "img/icon-faq.0c68bdd5.svg";